import materialTransfersReducer from "./materialTransfersReducer"
export default materialTransfersReducer
